/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const defaultData = [
  { name: 'Another Gender', value: 120 },
  { name: 'Male', value: 2200 },
  { name: 'Female', value: 450 },
  { name: 'Not Reported', value: 15 },
];

export const moreOptionsData = [
  {
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
    name: 'Experiential Interest',
    value: 220,
  },
  {
    description: 'Quisque tempor ut odio ac accumsan',
    name: 'Career Pragmatics',
    value: 450,
  },
  {
    description: 'Curabitur tempus est tortor, in iaculis mi eleifend non',
    name: 'Social Focus',
    value: 120,
  },
  {
    description:
      'Duis bibendum, lorem sit amet placerat sagittis, ante orci congue nibh, vel maximus ipsum urna eu felis',
    name: 'Exploration & Meaning',
    value: 15,
  },
  {
    description: 'Duis at sodales libero, a aliquet justo',
    name: 'Career Through Academics',
    value: 15,
  },
  { description: 'Sed a tortor urna', name: 'Grad School Bound', value: 15 },
];
